import {
  // getQueryString,
  handleError,
} from "../apiUtils";
import axios from "../axios";

export async function getCountries(pageSize: number) {
  try {
    const resp = await axios.get(`/api/countries/?pageSize=${pageSize}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function createCountry(country: object) {
  try {
    const resp = await axios.put("/api/countries/create/", country);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function updateCountry(country: object) {
  try {
    const resp = await axios.post("/api/countries/update/", country);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function deleteCountry(country_id: string) {
  try {
    const resp = await axios.delete("/api/countries/delete?id=" + country_id);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}
